import {
  DataGrid,
  DropDownButton,
  List,
  LoadPanel,
  ScrollView,
  TextBox,
} from "devextreme-react";
import Button from "devextreme-react/button";
import { DropDownButtonTypes } from "devextreme-react/cjs/drop-down-button";
import { ListRef } from "devextreme-react/cjs/list";
import {
  Column,
  DataGridRef,
  DataGridTypes,
  FilterRow,
  Item,
  SearchPanel,
  Sorting,
  Toolbar,
} from "devextreme-react/data-grid";
import {
  ButtonItem,
  Form,
  Item as FormItem,
  FormRef,
} from "devextreme-react/form";
import { LookupTypes } from "devextreme-react/lookup";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { DataSource } from "devextreme/common/data";
import { confirm } from "devextreme/ui/dialog";
import notify from "../../lib/notify";
import { produce } from "immer";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getAdministratorPanelUsers,
  sendDisableTwoFactorAuthenticationOnUserAccountRequest,
} from "../../api/administrator-panel";
import {
  addManagerr,
  addSubordinate,
  deleteManagers,
  deleteSubordinateEmployees,
  directSubordinateEmployee,
  disactiveUserAccount,
  getEmployeesWithoutManager,
} from "../../api/auth";
import {
  assignHeadManagers,
  fetchHeadManagersForManager,
  fetchManagers,
  fetchManagersAssignedToHeadManager,
  fetchRoles,
  fetchUserManagers,
  removeManagerFromHeadManager,
  updateIsManager,
  updateUserRole,
} from "../../api/users";
import ChangeUserEmailPopup from "../../components/change-user-email-popup/ChangeUserEmailPopup";
import ChangeUserPasswordPopup from "../../components/change-user-password-popup/ChangeUserPasswordPopup";
import DisableUserAccountLockPopup from "../../components/disable-user-account-lock-popup/DisableUserAccountLockPopup";
import SubstitutionPopup from "../../components/substitution-popup/SubstitutionPopup";
import { useAuth } from "../../contexts/auth";
import { useCompanyContext } from "../../contexts/company";
import { AdministratorPanelUser, RoleEnum } from "../../types";
import { useScreenSize } from "../../utils/media-query";
import "./AdminPanel.scss";
import UserProjectsPopup from "./UserProjectsPopup";

const companyName = (id: number | string | null | undefined): string => {
  if (id == null) return "";
  switch (Number(id)) {
    case 1:
      return "Invenio";
    case 2:
      return "Invenio QD";
    case 3:
      return "Quality & Human Services";
    case 4:
      return "IPSUPPORT";
    default:
      return "";
  }
};

export default function AdminPanel() {
  const { t } = useTranslation();
  const { isXSmall, isSmall } = useScreenSize();
  const isMobile = isXSmall || isSmall;
  const [filter, setFilter] = useState("");
  const dataGridRef = useRef<DataGridRef>(null);
  const [changePasswordForUserId, setChangePasswordForUserId] =
    useState<number>();
  const [managerId, setManagerId] = useState<number>();
  const [managerCompanyId, setManagerCompanyId] = useState<number>();
  const [changeEmailForUserId, setChangeEmailForUserId] = useState<number>();
  const [disableAccountLockForUserEmail, setDisableAccountLockForUserEmail] =
    useState<string>();
  const [popupVisableChangeRole, setPopupVisableChangeRole] = useState(false);
  const [employeeId, setEmployeeId] = useState<number>();
  const [companyId1, setCompanyId1] = useState<number>();
  const [roles, setRoles] = useState<{ id: number; name: string }[]>([]);

  const [selectedRole, setSelectedRole] = useState<string>("");
  const [popupVisableChangeManager, setPopupVisableChangeManager] =
    useState(false);
  const [popupVisableChangeManagerPopup, setPopupVisableChangeManagerPopup] =
    useState(false);
  const [managers, setManagers] = useState<
    { id: number; firstName: string; lastName: string; companyId: number }[]
  >([]);
  const [popupUserVisible, setPopupUserVisible] = useState(false);
  const [selectedManagerId, setSelectedManagerId] = useState<number>();
  const [selectedManagerCompanyId, setSelectedManagerCompanyId] =
    useState<number>();
  const [employeeIdEmployee, setEmployeeIdEmployee] = useState<number>();
  const [companyIdEmployee, setCompanyIdEmployee] = useState<number>();
  const [employeeIdManagerToAddEmployee, setEmployeeIdManagerToAddEmployee] =
    useState<number>(0);
  const [companyIdManagerToAddEmployee, setCompanyIdManagerToAddEmployee] =
    useState<number>(0);

  const [popupVisibleAddHeadManagers, setPopupVisibleAddHeadManagers] =
    useState(false);
  const [selectedManagerIds, setSelectedManagerIds] = useState<number[]>([]);
  const [selectedHeadManagerId, setSelectedHeadManagerId] = useState<number>(0);
  const [selectedHeadManagerCompanyId, setSelectedHeadManagerCompanyId] =
    useState<number>(0);
  const [employeesManager, setEmployeesManager] = useState<
    {
      employeeId: number;
      firstName: string;
      lastName: string;
      companyId: number;
    }[]
  >([]);

  const [managersEmpoloyee, setManagersEmployee] = useState<
    {
      employeeId: number;
      firstName: string;
      lastName: string;
      companyId: number;
    }[]
  >([]);

  const [employeeToAdd, setEmployeeToAdd] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [
    popupVisableSubordinateEmployees,
    setPopupVisableSubordinateEmployees,
  ] = useState(false);
  const { user, refreshUser } = useAuth();
  const { companyId } = useCompanyContext();
  const [isManagerCompanyId, setIsManagerCompanyId] = useState<number>(0);
  const [assignedManagers, setAssignedManagers] = useState<
    { managerId: number; managerCompanyId: number; managerFullName: string }[]
  >([]);
  const [popupVisibleAssignedManagers, setPopupVisibleAssignedManagers] =
    useState(false);
  const changeRoleFormRef = useRef<FormRef>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState<AdministratorPanelUser[]>([]);
  const [showProjectsPopupForUser, setShowProjectsPopupForUser] =
    useState<AdministratorPanelUser | null>(null);

  const isUserHeadAdministrator =
    user?.roles?.includes("AdministratorGlowny") ?? false;

  const getRoleName = (rowData: any): string => {
    if (!rowData) return "";
    return (
      rowData.role?.name ||
      rowData.roleName ||
      rowData.Role?.name ||
      rowData.role ||
      ""
    );
  };

  const canChangeManager = (rowData: any): boolean => {
    const role = getRoleName(rowData);
    return role === "Majster" || role === "Pracownik";
  };

  const canSeeSubordinates = (rowData: any): boolean => {
    const role = getRoleName(rowData);
    return rowData?.isManager === true && role !== "Manager";
  };

  const listRef = useRef<ListRef>(null);
  const [
    isSubordinateAddFormSubmitButtonDisabled,
    setIsSubordinateAddFormSubmitButtonDisabled,
  ] = useState(true);

  const fetchUsers = useCallback(async () => {
    try {
      setIsLoading(true);
      setUsers(
        await getAdministratorPanelUsers(
          isUserHeadAdministrator && companyId !== 0 ? companyId : undefined,
        ),
      );
    } catch (error) {
      setUsers([]);

      if (error instanceof Error) {
        notify(error.message, "error", 5000);
      } else {
        notify(t("common.errorOccurredWhileDataFetching"), "error", 5000);
      }
    } finally {
      setIsLoading(false);
    }
  }, [companyId, t]);

  useEffect(() => {
    downloadRoles();
    downloadManagers();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers, companyId]);

  const downloadManagers = async () => {
    const fetchUsers = async () => {
      const isHeadAdmin = user?.roles?.includes("AdministratorGlowny");

      const company = isHeadAdmin && companyId > 0 ? companyId : undefined;

      const response = await fetchManagers(company);

      if (response.isOk) {
        setManagers(response.data);
      } else {
        const managersList = response.data?.data || response.data || [];
        setManagers(managersList);
      }
    };
    fetchUsers();
  };

  const handlePopupChangeRole = (
    emploeeId: number,
    companyId: number,
    roleName: string,
  ) => {
    setPopupVisableChangeRole(true);
    setEmployeeId(emploeeId);
    setCompanyId1(companyId);
    setSelectedRole(roleName);
  };

  const downloadRoles = async () => {
    const fetchUsers = async () => {
      const response = await fetchRoles();
      if (response.isOk) {
        setRoles(response.data);
      } else {
        const rolesList = response.data.data || response.data || [];
        setRoles(rolesList);
      }
    };
    fetchUsers();
  };

  const downloadSubordinateEmployees = async (
    companyId: number,
    employeeId: number,
  ) => {
    // tylko stałe przypisania (UserManagerRelations) - wypożyczeni i zastępstwa nie mają
    // wiersza relacji, więc nie da się ich tutaj usunąć
    const response = await directSubordinateEmployee(companyId, employeeId);
    if (response.isOk) {
      setEmployeesManager(response.data);
    } else {
      const rolesList = response.data.data || response.data || [];
      setEmployeesManager(rolesList);
    }
  };

  const deleteSubordinateEmployee = async (
    companyId: number,
    employeeId: number,
  ) => {
    var result = await deleteSubordinateEmployees(
      companyId,
      employeeId,
      employeeIdManagerToAddEmployee,
      companyIdManagerToAddEmployee,
    );
    if (result.isOk) {
      notify(t("User deleted."), "success");
      downloadSubordinateEmployees(
        companyIdManagerToAddEmployee,
        employeeIdManagerToAddEmployee,
      );
    } else {
      notify(`${t("Error:")} ${result.error || t("Unknown error")}`, "error");
    }
    setPopupVisableSubordinateEmployees(true);
  };

  const deleteManager = async (companyId: number, employeeId: number) => {
    var result = await deleteManagers(
      companyIdEmployee || 0,
      employeeIdEmployee || 0,
      employeeId,
      companyId,
    );
    if (result.isOk) {
      DownloadUserManagers(employeeIdEmployee || 0, companyIdEmployee || 0);
      notify(t("User deleted."), "success");
    } else {
      notify(`${t("Error:")} ${result.error || t("Unknown error")}`, "error");
    }
  };

  const updateRole = async () => {
    const response = await updateUserRole(
      employeeId || 0,
      companyId1 || 0,
      selectedRole,
    );

    if (response.isOk) {
      dataGridRef.current?.instance().getDataSource().reload();
      refreshUser();
      notify(t("Role changed succesfull."), "success");
    } else {
      notify(`${t("Error:")} ${response.error || t("Unknown error")}`, "error");
    }
  };

  const isManager = async (employeeId, companyId) => {
    const response = await updateIsManager(employeeId, companyId);

    if (response.isOk) {
      notify(t("Manager changed succesfull."), "success");

      await fetchUsers();
    } else {
      notify(`${t("Error:")} ${response.error || t("Unknown error")}`, "error");
    }
  };

  const fetchEmployees = async () => {
    let company = 0;
    if (companyId === 0) {
      if (isManagerCompanyId === 0) {
        company = user?.companyId || 0;
      } else {
        company = isManagerCompanyId;
      }
    } else {
      company = companyId;
    }

    const result = await getEmployeesWithoutManager(company);
    if (result.isOk) {
      setEmployeeToAdd(result.data);
    } else {
      notify(`${t("Error:")} ${result.error || t("Unknown error")}`, "error");
    }
  };

  const addEmployees = async (
    entries: { companyId: number; employeeId: number }[],
  ) => {
    try {
      try {
        const result = await addSubordinate(
          entries,
          employeeIdManagerToAddEmployee,
          companyIdManagerToAddEmployee || 0,
        );
        if (result.isOk) {
          downloadSubordinateEmployees(
            companyIdManagerToAddEmployee,
            employeeIdManagerToAddEmployee,
          );
          return result.isOk
            ? t(`User added to manager.`)
            : `${t("Error:")} ${result.error || t("Unknown error")}`;
        } else {
          notify(
            `${t("Error:")} ${result.error || t("Unknown error")}`,
            "error",
          );
        }
      } catch (error: unknown) {
        return error instanceof Error
          ? t(`Error adding user to manager`)
          : t(`Error adding user to manager`);
      }
    } catch (error) {
      notify(`${t("Error:")} ${error || t("Unknown error")}`, "error");
    }
  };

  const addManager = async () => {
    try {
      const result = await addManagerr(
        companyIdEmployee || 0,
        employeeIdEmployee || 0,
        selectedManagerId || 0,
        selectedManagerCompanyId || 0,
      );

      if (result.isOk) {
        DownloadUserManagers(employeeIdEmployee || 0, companyIdEmployee || 0);

        notify(t("Manager added to user."), "success");
      } else {
        notify(`${t("Error:")} ${result.error || t("Unknown error")}`, "error");
      }
    } catch (error: unknown) {
      notify(
        `${t("Error:")} ${
          error instanceof Error ? error.message : t("Unknown error")
        }`,
        "error",
      );
    }
  };

  const disactiveActiveAccount = async (
    employeeId: number,
    companyId: number,
  ) => {
    try {
      const result = await disactiveUserAccount(employeeId, companyId);

      if (result.isOk) {
        notify(t("operationWasPerformedCorrectly"), "success");

        await fetchUsers();
      } else {
        notify(`${t("Error:")} ${result.error || t("Unknown error")}`, "error");
      }
    } catch (error: unknown) {
      notify(
        `${t("Error:")} ${
          error instanceof Error ? error.message : t("Unknown error")
        }`,
        "error",
      );
    }
  };

  const DownloadUserManagers = async (
    employeeId: number,
    companyId: number,
  ) => {
    const response = await fetchUserManagers(employeeId, companyId);
    if (response.isOk) {
      setManagersEmployee(response.data);
    } else {
      notify(`${t("Error:")} ${response.error || t("Unknown error")}`, "error");
    }
  };

  const handlePopupChangeManager = (employeeId: number, companyId: number) => {
    setEmployeeIdEmployee(employeeId);
    setCompanyIdEmployee(companyId);
    DownloadUserManagers(employeeId, companyId);
    setPopupVisableChangeManagerPopup(true);
  };

  const showEmployeeUnderManager = (employeeId: number, companyId: number) => {
    setIsManagerCompanyId(companyId);
    downloadSubordinateEmployees(companyId, employeeId);
    setEmployeeIdManagerToAddEmployee(employeeId);
    setCompanyIdManagerToAddEmployee(companyId);
    setPopupVisableSubordinateEmployees(true);
  };

  const deleteSubordinateEmployeeHandler = (user: any) => {
    deleteSubordinateEmployee(user.companyId, user.employeeId);
  };

  const deleteEmployeeManager = (user: any) => {
    deleteManager(user.companyId, user.employeeId);
  };

  const addPopupUser = () => {
    fetchEmployees().then(() => setPopupUserVisible(true));
  };

  const addManagers = () => {
    downloadManagers().then(() => setPopupVisableChangeManager(true));
  };

  const handleDisableTwoFactorAuthenticationOnUserAccount = useCallback(
    async (userId: number) => {
      setIsLoading(true);

      try {
        await sendDisableTwoFactorAuthenticationOnUserAccountRequest(userId);

        setUsers((users) =>
          produce(users, (draft) => {
            const user = draft.find((u) => u.id === userId);
            if (user) {
              user.twoFactorEnabled = false;
            }
          }),
        );

        notify(
          t("administrationPanel.twoFactorAuthenticationHasBeenDisabled"),
          "success",
          5000,
        );
      } catch (error) {
        if (error instanceof Error) {
          notify(error.message, "error", 5000);
        } else {
          notify(
            t("common.errorOccurredWhileProcessingYourRequest"),
            "error",
            5000,
          );
        }
      } finally {
        setIsLoading(false);
      }
    },
    [t],
  );

  const filteredUsers = (() => {
    const q = filter.trim().toLowerCase();
    if (!q) return users;
    return users.filter((u) => {
      const fullName = `${u.lastName ?? ""} ${u.firstName ?? ""}`
        .trim()
        .toLowerCase();
      const code = (u.code ?? "").toString().toLowerCase();
      const email = (u.email ?? "").toLowerCase();
      return (
        fullName.includes(q) || code.includes(q) || email.includes(q)
      );
    });
  })();

  const renderUserActions = (rowData: any) => (
    <DropDownButton
      stylingMode="text"
      displayExpr="text"
      icon="overflow"
      showArrowIcon
      dropDownOptions={{
        width: 300,
      }}
      activeStateEnabled={false}
      focusStateEnabled={false}
      items={[
        {
          text: t("administrationPanel.dataGrid.actions.changeUserPassword"),
          action: "changeUserPassword",
          id: rowData.id,
        },
        {
          text: t(
            "administrationPanel.dataGrid.actions.changeUserEmailAddress",
          ),
          action: "changeUserEmailAddress",
          id: rowData.id,
        },
        {
          text: t("administrationPanel.dataGrid.actions.unlockUserAccount"),
          action: "unlockUserAccount",
          email: rowData.email,
        },
        {
          text: t("administrationPanel.dataGrid.actions.changeRole"),
          action: "changeRole",
          companyId: rowData.companyId,
          employeeId: rowData.employeeId,
          role: rowData.role?.name,
        },
        ...(rowData.isManager === true
          ? [
              {
                text: t(
                  "administrationPanel.dataGrid.actions.downgradeToEmployee",
                ),
                action: "downgradeToEmployee",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(canChangeManager(rowData)
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.changeManager"),
                action: "changeManager",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(canSeeSubordinates(rowData)
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.subordinates"),
                action: "subordinates",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(rowData.role?.name === RoleEnum.Majster ||
        rowData.role?.name === RoleEnum.Kierownik
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.projects"),
                action: "projects",
                user: rowData,
              },
            ]
          : []),
        ...(rowData.isManager === true
          ? [
              {
                text: t(
                  "administrationPanel.dataGrid.actions.substitutionManger",
                ),
                action: "substitutionManger",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(rowData.role?.name === "Manager"
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.addHeadManagers"),
                action: "addHeadManagers",
                user: rowData,
              },
            ]
          : []),
        ...(rowData.role?.name === "Manager"
          ? [
              {
                text: t(
                  "administrationPanel.dataGrid.actions.viewHeadManagers",
                ),
                action: "viewHeadManagers",
                user: rowData,
              },
            ]
          : []),
        ...(rowData.deactivated === false
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.disableAccount"),
                action: "disableAccount",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(rowData.deactivated === true
          ? [
              {
                text: t("administrationPanel.dataGrid.actions.activeAccount"),
                action: "activeAccount",
                companyId: rowData.companyId,
                employeeId: rowData.employeeId,
              },
            ]
          : []),
        ...(rowData.twoFactorEnabled === true
          ? [
              {
                text: t(
                  "administrationPanel.dataGrid.actions.disableTwoFactorAuthentication",
                ),
                action: "disableTwoFactorAuthentication",
                id: rowData.id,
              },
            ]
          : []),
      ]}
      onItemClick={async (event: DropDownButtonTypes.ItemClickEvent) => {
        const data = event.itemData;
        if (!data) return;

        if (data.action === "changeUserPassword") {
          setChangePasswordForUserId(data.id);
        }

        if (data.action === "changeUserEmailAddress") {
          setChangeEmailForUserId(data.id);
        }

        if (data.action === "unlockUserAccount") {
          setDisableAccountLockForUserEmail(data.email);
        }

        if (data.action === "changeRole") {
          handlePopupChangeRole(
            data.employeeId,
            data.companyId,
            data.role,
          );
        }

        if (data.action === "downgradeToEmployee") {
          isManager(data.employeeId, data.companyId);
        }

        if (data.action === "changeManager") {
          handlePopupChangeManager(data.employeeId, data.companyId);
        }

        if (data.action === "subordinates") {
          showEmployeeUnderManager(data.employeeId, data.companyId);
        }

        if (data.action === "projects") {
          setShowProjectsPopupForUser(data.user);
        }

        if (data.action === "substitutionManger") {
          setManagerCompanyId(data.companyId);
          setManagerId(data.employeeId);
        }

        if (data.action === "addHeadManagers") {
          const user = data.user;

          if (user.role?.name !== "Manager") {
            notify(
              t("Only managers can have head managers assigned."),
              "warning",
            );
            return;
          }

          const response = await fetchManagers(user.companyId);
          if (!response.isOk) {
            notify(`${t("Error:")} ${response.error}`, "error");
            return;
          }

          setManagers(response.data);
          setSelectedManagerIds([]);
          setSelectedHeadManagerId(user.employeeId);
          setSelectedHeadManagerCompanyId(user.companyId);

          const existing = await fetchHeadManagersForManager(
            user.employeeId,
            user.companyId,
          );
          if (existing.isOk) {
            const already = existing.data.map((m) => m.managerId);
            setSelectedManagerIds(already);
          }

          setPopupVisibleAddHeadManagers(true);
        }

        if (data.action === "viewHeadManagers") {
          const user = data.user;

          if (user.role?.name !== "Manager") {
            notify(
              t("Only managers have assigned head managers."),
              "warning",
            );
            return;
          }

          const response = await fetchManagersAssignedToHeadManager(
            user.employeeId,
            user.companyId,
          );
          if (response.isOk) {
            setAssignedManagers(response.data);
            setSelectedHeadManagerId(user.employeeId);
            setSelectedHeadManagerCompanyId(user.companyId);
            setPopupVisibleAssignedManagers(true);
          } else {
            notify(`${t("Error:")} ${response.error}`, "error");
          }
        }

        if (data.action === "disableAccount") {
          disactiveActiveAccount(data.employeeId, data.companyId);
        }

        if (data.action === "activeAccount") {
          disactiveActiveAccount(data.employeeId, data.companyId);
        }

        if (data.action === "disableTwoFactorAuthentication") {
          const decision = await confirm(
            t(
              "administrationPanel.disableTwoFactorAuthenticationMessage",
            ),
            t("common.confirmation"),
          );

          if (decision === true) {
            await handleDisableTwoFactorAuthenticationOnUserAccount(data.id);
          }
        }
      }}
    />
  );

  return (
    <ScrollView useNative>
      <div className="p-6">
        {isLoading ? (
          <LoadPanel shading shadingColor="rgba(0, 0, 0, 0.3)" visible />
        ) : null}
        {changePasswordForUserId ? (
          <ChangeUserPasswordPopup
            userId={changePasswordForUserId}
            onClose={(passwordChanged: boolean) => {
              setChangePasswordForUserId(undefined);

              if (passwordChanged) {
                notify(
                  t("administrationPanel.notifications.userPasswordChanged"),
                  "success",
                );
              }
            }}
          />
        ) : null}
        {changeEmailForUserId ? (
          <ChangeUserEmailPopup
            userId={changeEmailForUserId}
            onClose={(emailChanged: boolean) => {
              setChangeEmailForUserId(undefined);

              if (emailChanged) {
                dataGridRef.current?.instance().refresh();

                notify(
                  t(
                    "administrationPanel.notifications.userEmailAddressChanged",
                  ),
                  "success",
                );
              }
            }}
          />
        ) : null}
        {disableAccountLockForUserEmail ? (
          <DisableUserAccountLockPopup
            email={disableAccountLockForUserEmail}
            onClose={(accountUnlocked: boolean) => {
              setDisableAccountLockForUserEmail(undefined);

              if (accountUnlocked) {
                notify(
                  t("administrationPanel.notifications.userAccountUnlocked"),
                  "success",
                );
              }
            }}
          />
        ) : null}
        {managerId && (
          <SubstitutionPopup
            managerId={managerId}
            managerCompanyId={managerCompanyId || 0}
            onClose={(passwordChanged: boolean) => {
              setManagerId(undefined);

              if (passwordChanged) {
                notify(
                  t("administrationPanel.notifications.userPasswordChanged"),
                  "success",
                );
              }
            }}
          />
        )}
        <div className="mb-1 text-2xl font-bold leading-none">
          {t("administrationPanel.header")}
        </div>

        {isMobile ? (
          <div className="admin-panel-mobile">
            <div className="admin-panel-mobile-filter">
              <TextBox
                value={filter}
                onValueChanged={(e) => setFilter(e.value ?? "")}
                placeholder={t("searchPlaceholder")}
                showClearButton
              />
            </div>
            <div className="admin-panel-mobile-list">
              {filteredUsers.length === 0 ? (
                <div className="admin-panel-mobile-empty">{t("No data")}</div>
              ) : (
                filteredUsers.map((u) => {
                  const fullName = `${u.lastName ?? ""} ${u.firstName ?? ""}`
                    .trim();
                  return (
                    <div
                      key={u.id}
                      className={`admin-panel-mobile-card${
                        u.deactivated
                          ? " admin-panel-mobile-card-inactive"
                          : ""
                      }`}
                    >
                      <div className="admin-panel-mobile-card-main">
                        <div className="admin-panel-mobile-card-name">
                          {fullName || "—"}
                        </div>
                        {u.code && (
                          <div className="admin-panel-mobile-card-line">
                            <b>
                              {t(
                                "administrationPanel.dataGrid.columns.acronym",
                              )}
                              :
                            </b>{" "}
                            {u.code}
                          </div>
                        )}
                        <div className="admin-panel-mobile-card-line">
                          <b>{t("company")}:</b> {companyName(u.companyId)}
                        </div>
                        {u.email && (
                          <div className="admin-panel-mobile-card-line">
                            <b>
                              {t(
                                "administrationPanel.dataGrid.columns.emailAddress",
                              )}
                              :
                            </b>{" "}
                            {u.email}
                          </div>
                        )}
                        <div className="admin-panel-mobile-card-line">
                          <b>{t("administrationPanel.role")}:</b>{" "}
                          {u.role?.name ?? "—"}
                        </div>
                        {u.supervisorFullName && (
                          <div className="admin-panel-mobile-card-line">
                            <b>
                              {t(
                                "administrationPanel.dataGrid.columns.manager",
                              )}
                              :
                            </b>{" "}
                            {u.supervisorFullName}
                          </div>
                        )}
                        <div className="admin-panel-mobile-card-badges">
                          {u.deactivated ? (
                            <span className="admin-panel-mobile-badge admin-panel-mobile-badge-warn">
                              {t(
                                "administrationPanel.dataGrid.actions.activeAccount",
                              )}
                            </span>
                          ) : (
                            <span className="admin-panel-mobile-badge admin-panel-mobile-badge-success">
                              {t("Active")}
                            </span>
                          )}
                          {u.twoFactorEnabled && (
                            <span className="admin-panel-mobile-badge admin-panel-mobile-badge-info">
                              2FA
                            </span>
                          )}
                          {u.isManager && (
                            <span className="admin-panel-mobile-badge admin-panel-mobile-badge-info">
                              {t("administrationPanel.manager")}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="admin-panel-mobile-card-actions">
                        {renderUserActions(u)}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        ) : (
        <DataGrid
          ref={dataGridRef}
          dataSource={users}
          remoteOperations
          showBorders
          allowColumnResizing
          allowColumnReordering
          searchPanel={{
            visible: true,
            placeholder: t("searchPlaceholder"),
          }}
          paging={{
            pageSize: 10,
          }}
          pager={{
            visible: true,
            showInfo: true,
            showNavigationButtons: true,
          }}
          hoverStateEnabled
        >
          <Toolbar>
            <Item
              name="searchPanel"
              location="before"
              locateInMenu="auto"
              cssClass="datagrid-search-panel-without-margin-left"
            />
          </Toolbar>
          <FilterRow visible />
          <Column
            dataField="code"
            dataType="string"
            caption={t("administrationPanel.dataGrid.columns.acronym")}
            minWidth={150}
            cellRender={({ data, value }) => (
              <span title={`${data?.employeeId ?? "-"}, ${data?.companyId ?? "-"}`}>
                {value}
              </span>
            )}
          />
          <Column
            dataField="lastName"
            dataType="string"
            caption={t("administrationPanel.dataGrid.columns.lastName")}
            minWidth={200}
          />
          <Column
            dataField="firstName"
            dataType="string"
            caption={t("administrationPanel.dataGrid.columns.firstName")}
            minWidth={200}
          />
          <Column
            dataField="companyId"
            dataType="string"
            caption={t("company")}
            customizeText={({ value }) => {
              switch (value) {
                case 1:
                  return "Invenio";
                case 2:
                  return "Invenio QD";
                case 3:
                  return "Quality & Human Services";
                case 4:
                  return "IPSUPPORT";
                default:
                  return "";
              }
            }}
            minWidth={200}
          />
          <Column
            dataField="email"
            dataType="string"
            caption={t("administrationPanel.dataGrid.columns.emailAddress")}
            minWidth={250}
          />
          <Column
            dataField="role.name"
            caption={t("administrationPanel.role")}
            minWidth={200}
          />
          <Column
            dataField="supervisorFullName"
            caption={t("administrationPanel.dataGrid.columns.manager")}
            minWidth={200}
          />
          <Column
            type="buttons"
            alignment="right"
            cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) =>
              renderUserActions(cellData.row.data)
            }
          />
        </DataGrid>
        )}
      </div>
      <div>
        {popupVisableChangeRole ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisableChangeRole(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 400}
            height={isMobile ? "100%" : "auto"}
            maxHeight={isMobile ? undefined : "80vh"}
            title={t("administrationPanel.changeRole")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <Form ref={changeRoleFormRef}>
              <FormItem
                dataField={t("administrationPanel.role")}
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: roles,
                  displayExpr: "name",
                  valueExpr: "name",
                  value: selectedRole,
                  onValueChanged: (e) => setSelectedRole(e.value),
                }}
                isRequired
              />
              <ButtonItem
                buttonOptions={{
                  text: t("administrationPanel.send"),
                  type: "default",
                  onClick: () => {
                    const validationResult = changeRoleFormRef
                      .current!.instance()
                      .validate();
                    if (validationResult.isValid) {
                      updateRole();
                      setPopupVisableChangeRole(false);
                    }
                  },
                }}
              />
            </Form>
          </Popup>
        ) : null}
        {popupVisableChangeManager ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisableChangeManager(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 400}
            height={isMobile ? "100%" : "auto"}
            maxHeight={isMobile ? undefined : "80vh"}
            title={t("administrationPanel.changeManager")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <Form>
              <FormItem
                label={{
                  text: t("administrationPanel.manager"),
                }}
                editorType="dxLookup"
                editorOptions={
                  {
                    showClearButton: true,
                    dataSource: managers,
                    displayExpr: (user) =>
                      user ? `${user.lastName} ${user.firstName}` : "",
                    valueExpr: "id",
                    value: selectedManagerId,
                    onValueChanged: (e) => {
                      setSelectedManagerId(e.value);
                      const selectedManager = managers.find(
                        (manager) => manager.id === e.value,
                      );
                      if (selectedManager) {
                        setSelectedManagerCompanyId(selectedManager.companyId);
                      }
                    },
                    dropDownOptions: {
                      showTitle: false,
                    },
                  } as LookupTypes.Properties
                }
              />
              <ButtonItem
                buttonOptions={{
                  text: t("administrationPanel.send"),
                  type: "default",
                  onClick: () => {
                    addManager()
                      .then(() =>
                        notify(
                          t("administrationPanel.managerAdded"),
                          "success",
                          5000,
                        ),
                      )
                      .catch(() =>
                        notify(
                          t("common.errorOccurredWhileProcessingYourRequest"),
                          "error",
                          5000,
                        ),
                      );
                    setPopupVisableChangeManager(false);
                  },
                }}
              />
            </Form>
          </Popup>
        ) : null}
        {popupVisableChangeManagerPopup ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisableChangeManagerPopup(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 800}
            height={isMobile ? "100%" : "auto"}
            maxHeight={isMobile ? undefined : "80vh"}
            title={t("subordinate.managers")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <div className="popup-projects">
              <div className="data-grid-projects">
                <DataGrid
                  dataSource={managersEmpoloyee}
                  keyExpr="employeeId"
                  showBorders
                  remoteOperations={false}
                  allowColumnResizing
                  paging={{
                    pageSize: 10,
                  }}
                  pager={{
                    visible: true,
                    showInfo: true,
                    showNavigationButtons: true,
                  }}
                >
                  <Sorting mode="single" />
                  <SearchPanel visible placeholder={t("project.Search...")} />
                  <FilterRow visible />
                  <Column
                    dataField="lastName"
                    dataType="string"
                    caption={t("subordinate.surname")}
                    minWidth={200}
                  />
                  <Column
                    dataField="firstName"
                    dataType="string"
                    caption={t("subordinate.name")}
                    minWidth={200}
                  />
                  <Column
                    dataField="companyId"
                    dataType="string"
                    caption={t("company")}
                    customizeText={({ value }) => {
                      switch (value) {
                        case 1:
                          return "Invenio";
                        case 2:
                          return "Invenio QD";
                        case 3:
                          return "Quality & Human Services";
                        case 4:
                          return "IPSUPPORT";
                        default:
                          return "";
                      }
                    }}
                    minWidth={150}
                  />
                  <Column
                    type="buttons"
                    alignment="right"
                    name="deleteUser"
                    buttons={[
                      {
                        icon: "trash",
                        onClick: (e) => {
                          if (e.row && !e.row.data.isRegistered) {
                            deleteEmployeeManager(e.row.data);
                          }
                        },
                        disabled: (e) =>
                          e.row ? e.row.data.isRegistered : true,
                        hint: t("subordinate.removeEmployee"),
                      },
                    ]}
                  />
                  <Toolbar>
                    <Item
                      location="before"
                      locateInMenu="auto"
                      name="searchPanel"
                      cssClass="datagrid-search-panel-without-margin-left"
                    />
                    <Item location="after" locateInMenu="auto">
                      <Button
                        type="default"
                        onClick={addManagers}
                        text={t("subordinate.addUser")}
                        icon="add"
                      />
                    </Item>
                  </Toolbar>
                </DataGrid>
              </div>
            </div>
          </Popup>
        ) : null}
        {popupVisableSubordinateEmployees ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisableSubordinateEmployees(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 800}
            height={isMobile ? "100%" : "auto"}
            maxHeight={isMobile ? undefined : "80vh"}
            title={t("subordinate.subordinateEmployees")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <DataGrid
              dataSource={employeesManager}
              keyExpr="employeeId"
              showBorders
              remoteOperations={false}
              allowColumnResizing
              searchPanel={{
                visible: true,
                placeholder: t("project.Search..."),
              }}
              paging={{
                pageSize: 10,
              }}
              pager={{
                visible: true,
                showInfo: true,
                showNavigationButtons: true,
              }}
            >
              <Toolbar>
                <Item
                  name="searchPanel"
                  location="before"
                  locateInMenu="auto"
                  cssClass="datagrid-search-panel-without-margin-left"
                />
                <Item location="after" locateInMenu="auto">
                  <Button
                    onClick={addPopupUser}
                    text={t("subordinate.addUser")}
                    icon="add"
                    type="default"
                  />
                </Item>
              </Toolbar>
              <FilterRow />
              <Column
                dataField="lastName"
                dataType="string"
                caption={t("subordinate.surname")}
                minWidth={200}
              />
              <Column
                dataField="firstName"
                dataType="string"
                caption={t("subordinate.name")}
                minWidth={200}
              />
              <Column
                dataField="companyId"
                dataType="string"
                caption={t("company")}
                customizeText={({ value }) => {
                  switch (value) {
                    case 1:
                      return "Invenio";
                    case 2:
                      return "Invenio QD";
                    case 3:
                      return "Quality & Human Services";
                    case 4:
                      return "IPSUPPORT";
                    default:
                      return "";
                  }
                }}
                minWidth={150}
              />
              <Column
                type="buttons"
                alignment="right"
                buttons={[
                  {
                    icon: "trash",
                    onClick: (e) => {
                      if (e.row && !e.row.data.isRegistered) {
                        deleteSubordinateEmployeeHandler(e.row.data);
                      }
                    },
                    disabled: (e) => (e.row ? e.row.data.isRegistered : true),
                    hint: t("subordinate.removeEmployee"),
                  },
                ]}
              />
            </DataGrid>
          </Popup>
        ) : null}
        {popupUserVisible ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupUserVisible(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 400}
            height={isMobile ? "100%" : "auto"}
            maxHeight={isMobile ? undefined : "80vh"}
            title={t("subordinate.transferEmployee")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <List
              ref={listRef}
              dataSource={
                new DataSource({
                  store: employeeToAdd,
                  paginate: false,
                })
              }
              keyExpr="value"
              displayExpr="label"
              searchExpr="label"
              showSelectionControls
              selectionMode="all"
              selectByClick
              searchEnabled
              height={400}
              onSelectedItemsChange={(values) =>
                setIsSubordinateAddFormSubmitButtonDisabled(values.length === 0)
              }
            />
            <ToolbarItem
              toolbar="bottom"
              location="after"
              widget="dxButton"
              options={{
                stylingMode: "contained",
                type: "default",
                text: t("project.send"),
                onClick: () => {
                  const selectedItemKeys = listRef.current
                    ?.instance()
                    .option("selectedItemKeys") as string[] | undefined;
                  if (selectedItemKeys) {
                    const entries = selectedItemKeys.map((v) => {
                      const [companyId, employeeId] = v.split(",").map(Number);

                      return {
                        companyId,
                        employeeId,
                      };
                    });

                    addEmployees(entries).then(() => {
                      setIsSubordinateAddFormSubmitButtonDisabled(true);
                      setPopupUserVisible(false);

                      notify(
                        t("subordinate.subordinateEmployeeAdded"),
                        "success",
                        5000,
                      );
                    });
                  }
                },
                disabled: isSubordinateAddFormSubmitButtonDisabled,
              }}
            />
          </Popup>
        ) : null}
        {popupVisibleAddHeadManagers ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisibleAddHeadManagers(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 500}
            height={isMobile ? "100%" : "auto"}
            title={t("administrationPanel.addHeadManagersTitle")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <Form>
              <FormItem
                dataField={t("administrationPanel.headManagers")}
                label={{ text: t("administrationPanel.selectHeadManagers") }}
                editorType="dxTagBox"
                editorOptions={{
                  dataSource: managers,
                  displayExpr: (item) =>
                    item ? `${item.lastName} ${item.firstName}` : "",
                  valueExpr: "id",
                  showClearButton: true,
                  searchEnabled: true,
                  value: selectedManagerIds,
                  onValueChanged: (e) => setSelectedManagerIds(e.value),
                }}
              />
              <ButtonItem
                buttonOptions={{
                  text: t("administrationPanel.save"),
                  type: "default",
                  onClick: async () => {
                    const selectedManagers = managers.filter((m) =>
                      selectedManagerIds.includes(m.id),
                    );
                    const managerIds = selectedManagers.map((m) => m.id);
                    const managerCompanyIds = selectedManagers.map(
                      (m) => m.companyId,
                    );

                    const result = await assignHeadManagers(
                      selectedHeadManagerId,
                      selectedHeadManagerCompanyId,
                      managerIds,
                      managerCompanyIds,
                    );

                    if (result.isOk) {
                      notify(
                        t("administrationPanel.notifications.managersAssigned"),
                        "success",
                      );
                      setPopupVisibleAddHeadManagers(false);
                    } else {
                      notify(`${t("Error:")} ${result.error}`, "error");
                    }
                  },
                }}
              />
            </Form>
          </Popup>
        ) : null}
        {popupVisibleAssignedManagers ? (
          <Popup
            wrapperAttr={{ class: "admin-panel-popup" }}
            visible
            onHiding={() => setPopupVisibleAssignedManagers(false)}
            fullScreen={isMobile}
            maxWidth={isMobile ? undefined : 600}
            height={isMobile ? "100%" : "auto"}
            title={t("administrationPanel.assignedManagers")}
            showCloseButton
            dragEnabled={!isMobile}
          >
            <DataGrid
              dataSource={assignedManagers}
              keyExpr="managerId"
              showBorders
              remoteOperations={false}
              height="auto"
            >
              <FilterRow visible />
              <Column
                dataField="managerFullName"
                caption={t("administrationPanel.dataGrid.columns.manager")}
                minWidth={200}
              />
              <Column
                dataField="managerCompanyId"
                caption={t("company")}
                customizeText={({ value }) => {
                  switch (value) {
                    case 1:
                      return "Invenio";
                    case 2:
                      return "Invenio QD";
                    case 3:
                      return "Quality & Human Services";
                    case 4:
                      return "IPSUPPORT";
                    default:
                      return "";
                  }
                }}
                minWidth={150}
              />
              <Column
                type="buttons"
                alignment="right"
                buttons={[
                  {
                    icon: "trash",
                    hint: t(
                      "administrationPanel.dataGrid.actions.removeManager",
                    ),
                    onClick: async (e) => {
                      const manager = e.row?.data;
                      const result = await removeManagerFromHeadManager(
                        selectedHeadManagerId,
                        selectedHeadManagerCompanyId,
                        manager.managerId,
                        manager.managerCompanyId,
                      );
                      if (result.isOk) {
                        notify(
                          t("administrationPanel.notifications.managerRemoved"),
                          "success",
                        );
                        setAssignedManagers((prev) =>
                          prev.filter(
                            (m) =>
                              !(
                                m.managerId === manager.managerId &&
                                m.managerCompanyId === manager.managerCompanyId
                              ),
                          ),
                        );
                      } else {
                        notify(`${t("Error:")} ${result.error}`, "error");
                      }
                    },
                  },
                ]}
              />
            </DataGrid>
          </Popup>
        ) : null}
        {showProjectsPopupForUser !== null ? (
          <UserProjectsPopup
            user={showProjectsPopupForUser}
            onClose={() => setShowProjectsPopupForUser(null)}
          />
        ) : null}
      </div>
    </ScrollView>
  );
}
